import React from "react"
import TablePagination from "components/Molecules/TablePagination"
import DateSelector from "components/Templates/DateSelector"
import ModuleHeader, { Description } from "components/Templates/ModuleHeader"
import { useSearchFilter } from "hooks/searchFilterHooks"
import TableActionsButton from "./TableActionsButton"

const ApprovalTableHeader = () => {
  const [{ search, date, page }, setFilter] = useSearchFilter()

  return (
    <ModuleHeader
      white={true}
      borderBottom="none"
      header={
        <div className="flex items-center">
          <Description icon="send-to" title="Stock take approval" />
          <TableActionsButton className="ml-6" />
        </div>
      }
      query={search}
      onQueryChange={query => {
        setFilter(prev => ({
          ...prev,
          search: query,
          page: 0,
        }))
      }}
    >
      <TablePagination
        className="mr-3"
        page={page}
        onPageChange={page => {
          setFilter(prev => ({
            ...prev,
            page,
          }))
        }}
      />
      <DateSelector
        value={date}
        onChange={(_, date) => {
          setFilter(prev => ({
            ...prev,
            date,
          }))
        }}
      />
    </ModuleHeader>
  )
}

export default ApprovalTableHeader
